import axios from "axios";
const jsonConfig = require("../../Config.json");


const getCandidateSubmissionField = async () => {
    let allResponse = {};
    try {
        const Response = await axios.get(jsonConfig.apiUrl + "candidateSubmissionField", {
            headers: {
                "x-functions-key": jsonConfig.key,
            },
        });

        allResponse = Response;

        return Promise.resolve(allResponse);
    }
    catch (error) {
        console.log("errrrrr", error);
        return Promise.reject(error);
    }
}

export default getCandidateSubmissionField;